module.exports = __webpack_public_path__ + "img/p9.992698f5.png";